import React, { PureComponent } from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translations from '../../requests/apa/Translator';
import * as api from '../../requests/loader';
import Button from '../Button';
import { playFullMedia } from '../../actions/playmedia';
import store from './../../store';
import Card from '../Card';
import LayersControl from '../../utils/LayersControl';
import FlagTimeOut from '../../AAF/TimeoutAAF/FlagTimeOut';
class ModalEndPlayer extends PureComponent {
  constructor(props) {
    super(props);

    this.calculateNext = this.calculateNext.bind(this);
    this.updateTimer = this.updateTimer.bind(this);
    this.playNextContent = this.playNextContent.bind(this);
    this.yellowButton = this.yellowButton.bind(this);
    this.play = this.play.bind(this);

    this.updateTimerIntervalId = null;

    const asset = props.asset || false;
    const content = props.content || false;
    let buttons = [];
    const callback = props.callback || false;
    const buttonsAlign = props.buttonsAlign || 'horizontal';
    this.next = props.next;
    this.flagFocus = false;

    this.state = {
      visible: false,
      timer: 10
    };

    this.calculateNext(this.next);

    if (props.buttons) {
      const tmp = props.buttons.map(button => {
        const newButton = Object.assign({}, button);
        const cb = newButton.props.onClick;
        newButton.props.onClick = e => {
          props.handleClose(e, cb);
        };
        return newButton;
      });
      buttons = [...buttons, ...tmp];
    }


    this.p = {
      buttonsAlign,
      buttons,
      yellowButton: this.yellowButton
    };

    if (asset) this.p['asset'] = asset;
    if (content) this.p['content'] = content;
  }

  yellowButton (e) {
    //Se realiza la funcion del boton cerrar.
    this.props.handleClose(e);
  }

  componentWillUnmount() {
    clearInterval(this.updateTimerIntervalId);
  }

  componentDidMount() {
    if (!this.next) {
      window.SpatialNavigation.focus('.content-grid .card-grid :first-child a');
    }
  }

  updateTimer() {
    if (this.state.timer === 0) {
      clearTimeout(this.updateTimerIntervalId);
      this.playNextContent();
    } else {
      this.setState(prevState => ({
        timer: prevState.timer - 1
      }));
    }
    if(!this.flagFocus){
      this.flagFocus = window.SpatialNavigation.focus('.button-end-player a.focusable-default');
    }
  }

  async calculateNext(next) {
    if (next) {
      FlagTimeOut.setIsFromSerie(true);
      this.setUpdateTimer();
      this.purchaseNextEpisode(next.id);
      this.dataNextEpisodeo(next);
    }
  }

  dataNextEpisodeo(next) {
    this.dataNextEpisode = {
      episodeNumber: next.extendedcommon.media.episode.number,
      description: next.description,
      imgSrc: next.image_still,
      seasonNumber: this.props.serieData.seasonNumber,
      title: next.title
    };
  }

  setUpdateTimer = () => {
    this.updateTimerIntervalId = setInterval(this.updateTimer, 1000);
  };

  async purchaseNextEpisode(groupId) {
    const result = await api.purchaseButtonInfo(groupId);
    this.setState({
      visible: JSON.parse(result.playButton.visible)
    });
    return result;
  }

  play = (gid, isReplay = false) => {
    const nextgid = {
      ispip: false,
      islive: false,
      ispreview: false,
      resume: 0,
      source: {
        videoid: gid
      },
      playerstate: 'PLAYING',
      event: null
    };

    if (isReplay) {
      nextgid.isReplay = isReplay;
    }

    if (this.recommendations) {
      Object.assign(nextgid, { recommendations: this.recommendations });
    }
    store.dispatch(playFullMedia(nextgid));
    this.props.handleClose(null);
  };

  async playNextContent() {
    this.updateTimerIntervalId && clearInterval(this.updateTimerIntervalId);
    const { next } = this.props;
    const pbi = await api.purchaseButtonInfo(next.id);
    this.stop();

    const wasPurchased = pbi && pbi.playButton && pbi.playButton.waspurchased;
    if (wasPurchased) {
      // Passing "true" value to force Ficha Component to update the store, dispatching setResume with the content_id of the next episode
      setTimeout(this.play, 100, next.id, true);
    } else {
      setTimeout(() => {
        this.setState({
          pbi: pbi,
          groupId: next.id
        });
      }, 1000);
    }
  }

  RecommendationsGrid({ recommendations }) {
    return (
      <div className="card-grid">
        {recommendations.map((r, index) => (
          <Card
            key={r.id}
            index={index}
            cover={r.image_small}
            group_id={r.id}
            type={'landscape'}
            focusable
            badgesAlign="right"
            data={r}
            clickHandler={() => this.handleRecommendationClick(r.id)}
          />
        ))}
      </div>
    );
  }

  stop = () => {
    if (LayersControl.isPlayerVisible()) {
      LayersControl.hidePlayer(true);
    }
    const nullPlayer = {
      ispip: false,
      islive: false,
      ispreview: false,
      playerstate: 'STOPPING',
      event: null
    };
    store.dispatch(playFullMedia(nullPlayer));
  };

  handleRecommendationClick(groupId = '') {
    this.stop();
    window.location.href = `/vcard/${groupId}`;
  }

  render() {
    const contentText = this.next ? (
      <div className="cont-end-player text-end-player">
        {' '}
        {`
                          ${Translations.get('finPlayer_Ser_next')}
                          ${Translations.get('finPlayer_Ser_starts')}
                          ${this.state.timer}"
                       `}{' '}
      </div>
    ) : (
      <div>{Translations.get('finPlayer_Pel_related')} </div>
    );

    const imgStyle = {
      background: this.dataNextEpisode
        ? `url("${this.dataNextEpisode.imgSrc}") no-repeat`
        : `url("") no-repeat`,
      backgroundSize: '100%',
      height: 250,
      width: 450,
      display: 'table',
      float: 'left'
    };

    const temp = Translations.get('season', 'Temporada');
    const episode = Translations.get('episode', 'Episodeo');
    const titlePelis = Translations.get(
      'title-pelis',
      '¿Quieres ver otra? Basándonos en tus gustos, te recomendamos:'
    );
    let titleYellow = '';
    if (this.props.serieData && this.dataNextEpisode) {
      titleYellow = `${temp} ${this.dataNextEpisode.seasonNumber} | ${episode} ${this.dataNextEpisode.episodeNumber} : ${this.dataNextEpisode.title}`;
    }

    return (
      <ModalWrapper {...this.p}>
        <div className="ModalEndPlayer">
          {this.state.visible > 0 && this.next && (
            <div className="content-next-episode">
              <div className="content-left-next-episode" style={imgStyle} />
              <div className="content-rigth-next-episode">
                <div className="data-next-episode">
                  <p className="text-end-player without-space">
                    <b>{Translations.get('next_season', 'Próximo Episodeo')}</b>
                  </p>
                  <p className="text-end-player title-yellow without-space">
                    <b>{titleYellow}</b>
                  </p>
                  {this.dataNextEpisode && (
                    <p className="text-end-player">
                      {this.dataNextEpisode.description}
                    </p>
                  )}
                </div>
                {contentText}
              </div>
              <div className="button-end-player">
                <Button
                  className={'focusable focusable-default'}
                  text={Translations.get('detail_play', 'Ver')}
                  iconClassName={'fa fa-play'}
                  colorCode={'blue'}
                  onClick={this.playNextContent}
                />
                <Button
                  className={'focusable'}
                  text={Translations.get('detail_cerrar', 'Cerrar')}
                  iconClassName={'fa fa-play'}
                  colorCode={'yellow'}
                  onClick={e => this.props.handleClose(e)}
                />
              </div>
            </div>
          )}
          {!this.next && (
            <div className="content-recommendations">
              <div className="content-ask">
                <p className="text-end-player without-space">{titlePelis}</p>
              </div>
              <div className="content-grid">
              </div>
              <div className="content-button">
                <Button
                  className={'focusable text-end-player'}
                  text={Translations.get('detail_cerrar', 'Cerrar')}
                  iconClassName={'fa fa-play'}
                  colorCode={'yellow'}
                  onClick={e => this.props.handleClose(e)}
                />
              </div>
            </div>
          )}
        </div>
      </ModalWrapper>
    );
  }
}

export default withOnClose(ModalEndPlayer);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalEndPlayer.jsx